// extracted by mini-css-extract-plugin
export default {"fotoSobreMim":"SobreMim_fotoSobreMim__wLquv","subtitulo":"SobreMim_subtitulo__K9ryl","paragrafo":"SobreMim_paragrafo__wGKv3"};